var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiProcessing(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sparkles"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27 17.0019L24.4115 18.3995C24.2595 18.485 24.0922 18.485 23.9607 18.3995L21.741 17L22.6392 19.7234C22.6938 19.8826 22.6699 20.0747 22.576 20.2358L21 22.9961L23.5851 21.5791C23.7371 21.4937 23.9044 21.4937 24.0359 21.5791L26.2573 23L25.3694 20.2378C25.3147 20.0786 25.3386 19.8864 25.4326 19.7253L27 17.0019Z",
    fill: "#F1FBFB"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M27 17.0019L24.4115 18.3995C24.2595 18.485 24.0922 18.485 23.9607 18.3995L21.741 17L22.6392 19.7234C22.6938 19.8826 22.6699 20.0747 22.576 20.2358L21 22.9961L23.5851 21.5791C23.7371 21.4937 23.9044 21.4937 24.0359 21.5791L26.2573 23L25.3694 20.2378C25.3147 20.0786 25.3386 19.8864 25.4326 19.7253L27 17.0019Z;M34 11.0058L25.3717 15.1986C24.8651 15.4549 24.3073 15.4549 23.8691 15.1986L16.4701 11L19.4639 19.1702C19.646 19.6477 19.5663 20.2242 19.2533 20.7075L14 28.9884L22.617 24.7373C23.1235 24.4811 23.6813 24.4811 24.1195 24.7373L31.5242 29L28.5646 20.7134C28.3825 20.2358 28.4622 19.6593 28.7752 19.176L34 11.0058Z;M27 17.0019L24.4115 18.3995C24.2595 18.485 24.0922 18.485 23.9607 18.3995L21.741 17L22.6392 19.7234C22.6938 19.8826 22.6699 20.0747 22.576 20.2358L21 22.9961L23.5851 21.5791C23.7371 21.4937 23.9044 21.4937 24.0359 21.5791L26.2573 23L25.3694 20.2378C25.3147 20.0786 25.3386 19.8864 25.4326 19.7253L27 17.0019Z",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#F1FBFB;#13C1BF;#F1FBFB",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.7655 31.316L38.8388 33.6522C38.5515 33.7955 38.2295 33.7955 37.9814 33.6522L33.7553 31.316L35.4658 35.8668C35.5702 36.136 35.5224 36.453 35.3439 36.7222L32.3452 41.3337L37.2633 38.9672C37.5505 38.8239 37.8726 38.8239 38.1207 38.9672L42.3511 41.3381L40.6624 36.7265C40.5579 36.4573 40.6015 36.1403 40.7843 35.8711L43.7655 31.316Z",
    fill: "#13C1BF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M43.7655 31.316L38.8388 33.6522C38.5515 33.7955 38.2295 33.7955 37.9814 33.6522L33.7553 31.316L35.4658 35.8668C35.5702 36.136 35.5224 36.453 35.3439 36.7222L32.3452 41.3337L37.2633 38.9672C37.5505 38.8239 37.8726 38.8239 38.1207 38.9672L42.3511 41.3381L40.6624 36.7265C40.5579 36.4573 40.6015 36.1403 40.7843 35.8711L43.7655 31.316Z;M38.7578 29.0005L34.8752 30.8654C34.6488 30.9797 34.395 30.9797 34.1995 30.8654L30.8691 29.0005L32.217 32.6331C32.2994 32.848 32.2616 33.1011 32.121 33.316L29.7578 36.9971L33.6336 35.108C33.8599 34.9936 34.1138 34.9936 34.3093 35.108L37.6431 37.0005L36.3123 33.3194C36.23 33.1045 36.2643 32.8515 36.4084 32.6366L38.7578 29.0005Z;M43.7655 31.316L38.8388 33.6522C38.5515 33.7955 38.2295 33.7955 37.9814 33.6522L33.7553 31.316L35.4658 35.8668C35.5702 36.136 35.5224 36.453 35.3439 36.7222L32.3452 41.3337L37.2633 38.9672C37.5505 38.8239 37.8726 38.8239 38.1207 38.9672L42.3511 41.3381L40.6624 36.7265C40.5579 36.4573 40.6015 36.1403 40.7843 35.8711L43.7655 31.316Z",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#13C1BF;#F1FBFB;#13C1BF",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.63616 11.416L2.41013 9.07988L4.12056 13.6306C4.22501 13.8999 4.18149 14.2168 3.9987 14.4861L1 19.0976L5.91804 16.731C6.20529 16.5877 6.52736 16.5877 6.77544 16.731L11.0058 19.1019L9.31715 14.4904C9.2127 14.2212 9.25622 13.9042 9.43901 13.635L12.4203 9.07988L7.49356 11.416C7.20631 11.5593 6.88424 11.5593 6.63616 11.416Z",
    fill: "#13C1BF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M6.63616 11.416L2.41013 9.07988L4.12056 13.6306C4.22501 13.8999 4.18149 14.2168 3.9987 14.4861L1 19.0976L5.91804 16.731C6.20529 16.5877 6.52736 16.5877 6.77544 16.731L11.0058 19.1019L9.31715 14.4904C9.2127 14.2212 9.25622 13.9042 9.43901 13.635L12.4203 9.07988L7.49356 11.416C7.20631 11.5593 6.88424 11.5593 6.63616 11.416Z;M10.706 14.6322L7.74561 13.0005L8.94378 16.179C9.01695 16.3671 8.98647 16.5885 8.85842 16.7765L6.75781 19.9975L10.2029 18.3446C10.4042 18.2445 10.6298 18.2445 10.8035 18.3446L13.767 20.0005L12.584 16.7796C12.5109 16.5915 12.5413 16.3701 12.6694 16.1821L14.7578 13.0005L11.3066 14.6322C11.1054 14.7323 10.8798 14.7323 10.706 14.6322Z;M6.63616 11.416L2.41013 9.07988L4.12056 13.6306C4.22501 13.8999 4.18149 14.2168 3.9987 14.4861L1 19.0976L5.91804 16.731C6.20529 16.5877 6.52736 16.5877 6.77544 16.731L11.0058 19.1019L9.31715 14.4904C9.2127 14.2212 9.25622 13.9042 9.43901 13.635L12.4203 9.07988L7.49356 11.416C7.20631 11.5593 6.88424 11.5593 6.63616 11.416Z",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#13C1BF;#F1FBFB;#13C1BF",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.7574 6.68798L46.5157 4.00009L43.6084 5.3766C43.4386 5.45911 43.2515 5.45911 43.1035 5.3766L40.6096 4.00009L41.6194 6.68364C41.6803 6.83996 41.6542 7.03102 41.5497 7.18735L39.7827 9.90998L42.6857 8.51175C42.8554 8.42925 43.0469 8.42925 43.1906 8.51175L45.6844 9.90998L44.6877 7.18735C44.6225 7.03537 44.6486 6.8443 44.7574 6.68798Z",
    fill: "#13C1BF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M44.7574 6.68798L46.5157 4.00009L43.6084 5.3766C43.4386 5.45911 43.2515 5.45911 43.1035 5.3766L40.6096 4.00009L41.6194 6.68364C41.6803 6.83996 41.6542 7.03102 41.5497 7.18735L39.7827 9.90998L42.6857 8.51175C42.8554 8.42925 43.0469 8.42925 43.1906 8.51175L45.6844 9.90998L44.6877 7.18735C44.6225 7.03537 44.6486 6.8443 44.7574 6.68798Z;M39.4521 10.8198L40.7578 9.00053L38.5988 9.9322C38.4727 9.98804 38.3338 9.98804 38.2239 9.9322L36.3719 9.00053L37.1217 10.8168C37.167 10.9226 37.1476 11.052 37.07 11.1578L35.7578 13.0005L37.9136 12.0542C38.0397 11.9983 38.1819 11.9983 38.2885 12.0542L40.1405 13.0005L39.4004 11.1578C39.3519 11.0549 39.3713 10.9256 39.4521 10.8198Z;M44.7574 6.68798L46.5157 4.00009L43.6084 5.3766C43.4386 5.45911 43.2515 5.45911 43.1035 5.3766L40.6096 4.00009L41.6194 6.68364C41.6803 6.83996 41.6542 7.03102 41.5497 7.18735L39.7827 9.90998L42.6857 8.51175C42.8554 8.42925 43.0469 8.42925 43.1906 8.51175L45.6844 9.90998L44.6877 7.18735C44.6225 7.03537 44.6486 6.8443 44.7574 6.68798Z",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#13C1BF;#F1FBFB;#13C1BF",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.3545 38.0911L17.4472 39.4676C17.2774 39.5501 17.0859 39.5501 16.9423 39.4676L14.4485 38.0867L15.4582 40.7703C15.5191 40.9266 15.493 41.1177 15.3886 41.274L13.6172 44.001L16.5202 42.6028C16.6899 42.5202 16.8814 42.5202 17.025 42.6028L19.5189 44.001L18.5222 41.2783C18.4613 41.122 18.4874 40.931 18.5918 40.7746L20.3545 38.0911Z",
    fill: "#13C1BF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M20.3545 38.0911L17.4472 39.4676C17.2774 39.5501 17.0859 39.5501 16.9423 39.4676L14.4485 38.0867L15.4582 40.7703C15.5191 40.9266 15.493 41.1177 15.3886 41.274L13.6172 44.001L16.5202 42.6028C16.6899 42.5202 16.8814 42.5202 17.025 42.6028L19.5189 44.001L18.5222 41.2783C18.4613 41.122 18.4874 40.931 18.5918 40.7746L20.3545 38.0911Z;M20.7578 35.0035L18.6002 35.9345C18.4742 35.9903 18.3321 35.9903 18.2255 35.9345L16.3747 35.0005L17.1241 36.8155C17.1693 36.9212 17.1499 37.0505 17.0724 37.1562L15.7578 39.0005L17.9122 38.0549C18.0382 37.9991 18.1803 37.9991 18.2869 38.0549L20.1377 39.0005L19.398 37.1591C19.3528 37.0534 19.3721 36.9242 19.4497 36.8184L20.7578 35.0035Z;M20.3545 38.0911L17.4472 39.4676C17.2774 39.5501 17.0859 39.5501 16.9423 39.4676L14.4485 38.0867L15.4582 40.7703C15.5191 40.9266 15.493 41.1177 15.3886 41.274L13.6172 44.001L16.5202 42.6028C16.6899 42.5202 16.8814 42.5202 17.025 42.6028L19.5189 44.001L18.5222 41.2783C18.4613 41.122 18.4874 40.931 18.5918 40.7746L20.3545 38.0911Z",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#13C1BF;#F1FBFB;#13C1BF",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiProcessing);
export default __webpack_public_path__ + "static/media/ai-processing.d0993d80873294bc818fe2a58df89e16.svg";
export { ForwardRef as ReactComponent };